import { Outlet, Link } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import TourOverlay from "@/components/tour/TourOverlay";
import CommandBar from "@/components/ai/CommandBar";

export default function AppLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ImpersonationBanner />
      <div className="flex flex-1 min-h-0">
        <Sidebar />
        <main className="flex-1 min-w-0 flex flex-col">
          <div className="flex-1 max-w-[1400px] mx-auto w-full px-6 lg:px-10 py-8 animate-fade-in">
            <Outlet />
          </div>
          {/* Footer legale */}
          <footer className="border-t border-border/50 py-3 px-6 lg:px-10">
            <div className="max-w-[1400px] mx-auto flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-muted-foreground/60 justify-end">
              <Link to="/privacy" className="hover:text-muted-foreground transition-colors">Privacy</Link>
              <Link to="/terms" className="hover:text-muted-foreground transition-colors">Termini</Link>
              <Link to="/dpa" className="hover:text-muted-foreground transition-colors">DPA</Link>
              <Link to="/cookies" className="hover:text-muted-foreground transition-colors">Cookie</Link>
            </div>
          </footer>
        </main>
      </div>
      <TourOverlay />
      <CommandBar />
    </div>
  );
}
